<template>
  <div class="flex flex-col max-w-l grow">
    <div class="mb-8 text-center flex flex-col gap-4">
      <span class="text-2xl sm:text-3xl font-medium">
        {{ $t(`${trPrefix}forgotpw`) }}
      </span>

      <span>
        {{ $t(`${trPrefix}dontWorry`) }}
      </span>
    </div>

    <WebccInput
      v-model="email"
      class="mb-4"
      name="email"
      :label="`${trPrefix}email`"
      type="email"
      @keyup.enter.stop="submit"
    />

    <div
      v-if="emailError"
      class="my-4 rounded border border-err p-4 text-err md:w-1/3"
    >
      {{ $t(`${trPrefix}emailRequired`) }}
    </div>

    <WebccButton
      :disabled="email === '' || !email.includes('@')"
      class="mb-4 w-full"
      variant="theme"
      size="lg"
      :loading
      @click="submit"
    >
      {{ $t(`${trPrefix}sendReset`) }}
    </WebccButton>

    <UserAgreement />
  </div>
</template>

<script lang="ts" setup>
const trPrefix = 'components.auth.recover.forgotPasswordForm.'

const emit = defineEmits<{
  goTo: [value: AuthFlowType]
  isReady: []
}>()

const auth = useAuthStore()
const authFlow = useAuthFlow()

const email = ref('')
const emailError = ref(false)
const loading = ref(false)

onMounted(() => {
  emit('isReady')
})

async function submit() {
  loading.value = true

  try {
    await auth.recoverStart()
  } catch (error) {
    loading.value = false
    if (error instanceof SessionExistsAuthError) {
      authFlow.toggle(false)
    }
  }

  try {
    const emailValidationResult = await useValidation().email(email.value)
    if (emailValidationResult!.score < 3) {
      console.log('wrong email')
      throw new Error('wrong email')
    }
  } catch (error) {
    console.error(error)
    emailError.value = true
    loading.value = false
  }

  try {
    await auth.recoverComplete({ email: email.value })

    emit('goTo', 'recoverVerification')
  } finally {
    loading.value = false
  }
}
</script>
